import script from "./register.vue?vue&type=script&setup=true&lang=ts"
export * from "./register.vue?vue&type=script&setup=true&lang=ts"

import "./register.vue?vue&type=style&index=0&id=d9d79f82&scoped=true&lang=css"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9d79f82"]])

export default __exports__